export const data = {
    "type": "FeatureCollection",
    "features": [
        {
            'type': 'Feature',
            "properties": {
                "name": '~5 min'
            },
            'geometry': {
                'type': 'Polygon',
                'coordinates': [
                    [
                        [
                            30.347522, 59.915340
                        ],
                        [
                            30.350097, 59.914953
                        ],
                        [
                            30.348316, 59.912124
                        ],
                        [
                            30.345677, 59.912549
                        ]
                    ]
                ]
            }
        }, {
            'type': 'Feature',
            "properties": {
                "name": '~2 min'
            },
            'geometry': {
                'type': 'Polygon',
                'coordinates': [
                    [
                        [
                            30.340816, 59.910849
                        ],
                        [
                            30.343884, 59.910284
                        ],
                        [
                            30.342478, 59.908412
                        ],
                        [
                            30.339506, 59.909176
                        ],
                        [
                            30.340816, 59.910849
                        ]
                    ]
                ]
            }
        }, {
            'type': 'Feature',
            "properties": {
                "name": '~2 min'
            },
            'geometry': {
                'type': 'Polygon',
                'coordinates': [
                    [
                        [
                            30.340634, 59.915352
                        ],
                        [
                            30.342147, 59.915597
                        ],
                        [
                            30.342467, 59.915283
                        ],
                        [
                            30.340691, 59.915001
                        ],
                        [
                            30.340634, 59.915352
                        ]
                    ]
                ]
            }
        }
    ]
}
